import { render, staticRenderFns } from "./HistoryStudy.vue?vue&type=template&id=4a5a3928&scoped=true"
import script from "./HistoryStudy.vue?vue&type=script&lang=js"
export * from "./HistoryStudy.vue?vue&type=script&lang=js"
import style0 from "./HistoryStudy.vue?vue&type=style&index=0&id=4a5a3928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a3928",
  null
  
)

export default component.exports